import { useEffect, useState } from "react";
import axios from "axios";
import { Handshake } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SponsorsPage() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    axios.get(`${API}/sponsors`).then(r => setSponsors(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="sponsors-page" className="aged-paper">
      {/* Header */}
      <section className="py-16 sm:py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <div className="segment-label">Partners</div>
            <div className="flex-1 h-[1px] bg-foreground/15" />
          </div>
          <h1 data-testid="sponsors-title" className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase mb-4">
            Our Sponsors
          </h1>
          <div className="h-[3px] w-16 gold-accent" />
          <p className="font-body text-sm text-muted-foreground uppercase tracking-widest mt-4">
            The territory is proudly supported by
          </p>
        </div>
      </section>

      <div className="vintage-divider" />

      <section className="py-16 sm:py-24 px-4">
        <div className="max-w-7xl mx-auto">
          {sponsors.length === 0 ? (
            <div className="py-20 text-center">
              <Handshake size={32} className="mx-auto text-muted-foreground mb-4" />
              <p className="font-heading text-xl text-muted-foreground uppercase mb-2">Sponsorship Opportunities</p>
              <p className="font-body text-sm text-muted-foreground">
                Interested in sponsoring the Piedmont Wrestling Club? Contact us.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
              {sponsors.map(s => (
                <div key={s.id} data-testid={`sponsor-card-${s.id}`}>
                  {s.website_url ? (
                    <a href={s.website_url} target="_blank" rel="noopener noreferrer" className="block group">
                      <SponsorCard sponsor={s} />
                    </a>
                  ) : (
                    <SponsorCard sponsor={s} />
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Sponsorship CTA */}
          {sponsors.length > 0 && (
            <div className="mt-16 text-center">
              <div className="h-[1px] bg-foreground/10 mb-8" />
              <p className="font-heading text-lg uppercase text-muted-foreground mb-2">Become a Sponsor</p>
              <p className="font-body text-sm text-muted-foreground">
                Want to support the territory? Reach out at{" "}
                <a href="mailto:Piedmontwrestlingclub@Gmail.com" className="text-[#B09030] hover:underline">
                  Piedmontwrestlingclub@Gmail.com
                </a>
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

function SponsorCard({ sponsor }) {
  return (
    <div className="bg-[#0D0D0D] p-6 flex flex-col items-center justify-center aspect-square group-hover:bg-[#1A1510] transition-colors">
      {sponsor.logo_url ? (
        <img
          src={sponsor.logo_url}
          alt={sponsor.name}
          className="max-w-full max-h-28 object-contain mb-4"
        />
      ) : (
        <div className="w-20 h-20 flex items-center justify-center mb-4">
          <p className="font-heading text-3xl text-[#B09030]/30">{sponsor.name.charAt(0)}</p>
        </div>
      )}
      <p className="font-heading text-sm text-[#E8DFC8] uppercase text-center">{sponsor.name}</p>
      {sponsor.tier && sponsor.tier !== "standard" && (
        <p className="font-body text-[9px] text-[#B09030] uppercase tracking-widest mt-1">{sponsor.tier} Sponsor</p>
      )}
    </div>
  );
}
